import { AddToCurrentCartSucceededResult } from '../CartsState';
import { RootState } from '../../RootState';
import selectCurrentCartPageActions from './selectCurrentCartPageActions';

const selectSucceededAddToCurrentCartResults = (
  state: RootState
): ReadonlyArray<AddToCurrentCartSucceededResult> =>
  selectCurrentCartPageActions(state).addToCurrentCart.succeeded;

export default selectSucceededAddToCurrentCartResults;
